import * as React from 'react';
import {WrappedFieldProps} from 'redux-form';
import * as Dictionary from 'Models/Dictionary';

type Props = {
    label: string;
    disabled: boolean;
    onCarRemoval: Function;
    onListOpen: Function;
    labelNoCar: string;
};

class ChosenCarField extends React.PureComponent<WrappedFieldProps & Props> {
    public render() {
        const {input, meta, label, disabled} = this.props;

        return (
            <div className={`form-field ${disabled ? ' form-field--disabled' : ''}`}>
                <label htmlFor={input.name} className="form-field__label">{label}</label>
                {input.value ? (
                    <div className="assign-item">
                        <div className="assign-item__image-wrapper">
                            <img src={Dictionary.CarCategoryTableFilters.get(input.value.carCategory)} alt=""
                                 className="assign-item__img"/>
                        </div>
                        <div className="assign-item__title-1">
                            {input.value.vin} [{input.value.deviceId}]
                        </div>
                        <div className="assign-item__delete">
                            <i className="icon--plus_sign rotate-45deg" onClick={() => this.props.onCarRemoval()}/>
                        </div>
                    </div>
                ) : (
                    <p className="flex flex--center">
                        <span className="mr-7">{this.props.labelNoCar}</span>
                        <i className="icon--plus_sign " onClick={() => this.props.onListOpen()}/>
                    </p>
                )}

                {(meta.touched &&
                    (meta.error && (
                        <div className="form-field__error">
                            {meta.error}
                        </div>
                    ))) ||
                (meta.warning && <span>{meta.warning}</span>)}
            </div>
        );
    }
}

export default ChosenCarField;



// WEBPACK FOOTER //
// ./src/components/Layout/Form/Fields/ChosenCarField.tsx